const timelineMobile = function() {
  if (window.innerWidth < 750) {
    const headerHeigt = parseInt(getComputedStyle(document.querySelector('.mega-sticky-header')).height);
    const ourStorySection = document.querySelector('.our-story');
    const ourStoryHeight = parseInt(getComputedStyle(ourStorySection).height);
    const ourStoryTopOffset = ourStorySection.offsetTop - headerHeigt;
    const ourStoryBottomOffset = ourStoryTopOffset + ourStoryHeight;
    const timelineMobileCircle = document.querySelector('.time-line-mobile .time-line_circle');

    if (this.pageYOffset >= ourStoryTopOffset && this.pageYOffset < ourStoryBottomOffset) {
      const scrollDepth = this.pageYOffset - ourStoryTopOffset;
      const timelineLeftPosition = (scrollDepth / ourStoryHeight) * 100;

      timelineMobileCircle.style.left = `${timelineLeftPosition}%`;
    }
  }
}
window.addEventListener('scroll', timelineMobile)